import restapi from 'utils/restapi';
import { addLang } from "utils/addLang";

import { baseErrorsHandlerDecorator } from 'redux/utils';

import {
  VALIDATE_SHOPIFY_URL_SUCCESS,
  VALIDATE_SHOPIFY_URL_ERROR,
  CLEAR_VALIDATE_SHOPIFY_URL,
  CONNECT_SHOPIFY_STORE_SUCCESS,
  CONNECT_SHOPIFY_STORE_ERROR,
  CLEAR_CONNECT_SHOPIFY_STORE,
  SHOPIFY_STORE_INFO_SUCCESS,
  SHOPIFY_STORE_INFO_ERROR,
  CLEAR_SHOPIFY_STORE_INFO,
  DISCONNECT_SHOPIFY_STORE_SUCCESS,
  DISCONNECT_SHOPIFY_STORE_ERROR,
  CLEAR_DISCONNECT_SHOPIFY_STORE,
  RESYNC_SHOPIFY_STORE_SUCCESS,
  RESYNC_SHOPIFY_STORE_ERROR,
  CLEAR_RESYNC_SHOPIFY_STORE,
  SYNCHRONIZE_SHOPIFY_PRODUCTS_SUCCESS,
  SYNCHRONIZE_SHOPIFY_PRODUCTS_ERROR,
  CLEAR_SYNCHRONIZE_SHOPIFY_PRODUCTS,
} from 'redux/integrations/types';

export const validateShopifyUrl = url => baseErrorsHandlerDecorator(
  VALIDATE_SHOPIFY_URL_SUCCESS,
  VALIDATE_SHOPIFY_URL_ERROR,
  () => restapi.post(addLang('users/integrations/shopify/validate-url/'), { url }),
  false,
);

export const clearValidateShopifyUrl = () => dispatch => {
  dispatch({
    type: CLEAR_VALIDATE_SHOPIFY_URL,
  });
};

export const connectShopifyStore = (code, hmac, shop) => baseErrorsHandlerDecorator(
  CONNECT_SHOPIFY_STORE_SUCCESS,
  CONNECT_SHOPIFY_STORE_ERROR,
  () => restapi.post(addLang('users/integrations/shopify/connect/'), {
    code,
    hmac,
    shop,
  }),
  false,
);

export const clearConnectShopifyStore = () => dispatch => {
  dispatch({
    type: CLEAR_CONNECT_SHOPIFY_STORE,
  });
};

export const getShopifyStoreInfo = () => baseErrorsHandlerDecorator(
  SHOPIFY_STORE_INFO_SUCCESS,
  SHOPIFY_STORE_INFO_ERROR,
  () => restapi.get(addLang('users/integrations/shopify/info/')),
  false,
);

export const clearShopifyStoreInfo = () => dispatch => {
  dispatch({
    type: CLEAR_SHOPIFY_STORE_INFO,
  });
};

export const disconnectShopifyStore = formData => baseErrorsHandlerDecorator(
  DISCONNECT_SHOPIFY_STORE_SUCCESS,
  DISCONNECT_SHOPIFY_STORE_ERROR,
  () => restapi.post(addLang('users/integrations/disconnect/'), formData),
  true,
);

export const clearDisconnectShopifyStore = () => dispatch => {
  dispatch({
    type: CLEAR_DISCONNECT_SHOPIFY_STORE,
  });
};

export const resyncShopifyStore = () => baseErrorsHandlerDecorator(
  RESYNC_SHOPIFY_STORE_SUCCESS,
  RESYNC_SHOPIFY_STORE_ERROR,
  () => restapi.post(addLang('users/integrations/shopify/resync/')),
  false,
);

export const clearResyncShopifyStore = () => dispatch => {
  dispatch({
    type: CLEAR_RESYNC_SHOPIFY_STORE,
  });
};

export const synchronizeShopifyProducts = value => baseErrorsHandlerDecorator(
  SYNCHRONIZE_SHOPIFY_PRODUCTS_SUCCESS,
  SYNCHRONIZE_SHOPIFY_PRODUCTS_ERROR,
  () => restapi.post(addLang('users/integrations/shopify/info/'), { sync_products: value }),
  false,
  true /* actionSucces */,
);

export const clearSynchronizeShopifyProducts = () => dispatch => {
  dispatch({
    type: CLEAR_SYNCHRONIZE_SHOPIFY_PRODUCTS,
  });
};
